import React from 'react'
import MaterialSymbol from '../material-symbol'

const Repeat = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="repeat" {...props} />
))

Repeat.displayName = 'Repeat'

export default Repeat
